import { useCallback, useEffect, useState } from "react";
import { OdcService } from "../services/OdcService";
import { CentralOdcService } from "../services/CentralOdcService";

export const useHookCentralOdcDetail = ({id}) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await CentralOdcService.show({ id: id });
            setData(res?.data?.data);
        } catch (err) {
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        getData();
    }, [getData]);

    return {
        data,
        loading,
        error,
        
        refreshData: () => getData(),
    }
}